import React from 'react';
import { usePublicOptIn } from './hooks/usePublicOptIn';
import { BroadcastPreferencePage } from './BroadcastPreferencePage';

export const OptIn = () => {
  const { optIn, isLoading, isSuccess, isError, error } = usePublicOptIn();

  return (
    <BroadcastPreferencePage
      onSubmit={optIn}
      isLoading={isLoading}
      isSuccess={isSuccess}
      isError={isError}
      error={error}
      successContent={{
        title: 'Receive SmPC Updates',
        message: 'You have registered to receive SmPC updates. You can expect to receive your first update via email shortly.',
        linkText: 'Unsubscribe',
        linkAction: 'opt-out',
      }}
      invalidTokenContent={{
        title: 'Receive SmPC Updates',
        message: 'This opt-in link is invalid or has expired. Please check the link in your email or contact your administrator.',
      }}
      actionLabel="opt-in"
    />
  );
};
